/**
 * Field sets for selective endpoint dispatch — shared by the primary and
 * co-borrower auto-save handlers. A dirty field's membership decides which
 * backend endpoint receives it (borrower vs consent vs demographics).
 */
export const BORROWER_FIELDS = new Set([
  "firstName",
  "lastName",
  "middleName",
  "suffix",
  "email",
  "phone",
  "citizenship",
  "maritalStatus",
  "dependentsAgesYears",
  "employmentStatus",
  "hasBankruptcy",
  "bankruptcyDate",
  "nearestRelativeName",
  "nearestRelativeRelationship",
  "nearestRelativePhone",
]);
export const CONSENT_FIELDS = new Set(["dateOfBirth", "ssn"]);
export const DEMOGRAPHICS_FIELDS = new Set([
  "ethnicities",
  "races",
  "biologicalSex",
]);
